import { getAppContext, getLoginUrlParams as getLoginUrlParamsOriginal } from '@gef-ui/redux-common/selectors/appContext';
import compose from "ramda/es/compose";
import converge from "ramda/es/converge";
import none from "ramda/es/none";
import pick from "ramda/es/pick";
import prop from "ramda/es/prop";
import argumentsToList from "ramda-extension/es/argumentsToList";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { createSelector } from 'reselect';
/**
 * Get object containing information needed to request authorization from agw
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getLoginUrlParams(state)
 *
 */ export const getLoginUrlParams = getLoginUrlParamsOriginal;
/**
 * Get object containing appContext clientId and redirectUri params
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getClientIdAndRedirectUri(state)
 *
 */ export const getClientIdAndRedirectUri = createSelector(getAppContext, pick([
    'clientId',
    'redirectUri'
]));
/**
 * Check whether both access and refresh tokens are present in appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	hasAuthorizationTokens(state)
 *
 */ export const hasAuthorizationTokens = createSelector(getAppContext, converge(compose(none(isNilOrEmpty), argumentsToList), [
    prop('accessToken'),
    prop('refreshToken')
]));
